export interface SmartTVDevice extends SmartTVHash {
    device: string;
}

export interface SmartTVHash {
    hash: string;
}
